(function() {
  if (!document.body.classList.contains('template-product-colares-mensagem')) return;

  function buildBar() {
    if (document.querySelector('.figu-bar-nav')) return;

    var carousel = document.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.product-gallery__media');
    if (!slides.length) return;

    var gallery = document.querySelector('.product-gallery');
    if (!gallery || !gallery.parentNode) return;

    var count = slides.length;
    var current = 0;

    var bar = document.createElement('div');
    bar.className = 'figu-bar-nav';

    for (var i = 0; i < count; i++) {
      var seg = document.createElement('button');
      seg.className = 'figu-bar-nav__seg' + (i === 0 ? ' figu-bar-nav__seg--active' : '');
      seg.setAttribute('type', 'button');
      seg.setAttribute('aria-label', 'Imagem ' + (i + 1));
      bar.appendChild(seg);
    }

    gallery.parentNode.insertBefore(bar, gallery.nextSibling);

    function updateBar(index) {
      current = index;
      bar.querySelectorAll('.figu-bar-nav__seg').forEach(function(s, i) {
        s.classList.toggle('figu-bar-nav__seg--active', i === index);
      });
    }

    var scrollTimer;
    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var index = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        if (index !== current) updateBar(index);
      }, 50);
    }, { passive: true });

    bar.querySelectorAll('.figu-bar-nav__seg').forEach(function(seg, i) {
      seg.addEventListener('click', function() {
        carousel.scrollTo({ left: i * carousel.offsetWidth, behavior: 'smooth' });
        updateBar(i);
      });
    });
  }

  if (document.readyState === 'complete') {
    setTimeout(buildBar, 500);
  } else {
    window.addEventListener('load', function() {
      setTimeout(buildBar, 500);
    });
  }
})();
